/**
 * Normalizes indicators to array format
 * Accepts: array, object (converts to array), or any other type (returns empty array)
 *
 * @param raw - Raw indicators data from any source
 * @returns Always returns an array
 */
export function normalizeIndicators(raw: any): any[] {
  // Already an array - return as-is
  if (Array.isArray(raw)) {
    return raw;
  }

  // Object format (legacy) - convert to array of values
  if (raw && typeof raw === 'object' && raw !== null) {
    return Object.values(raw);
  }

  // Any other type (null, undefined, number, string) - return empty array
  return [];
}
